import { TravellerActionGroupAction } from 'api/traveller-actions/requests';

import { isActionError } from '../action-error';

// The Send-form step itself never fails; it has failed once every channel it sends on has.
export const isComboSendFormError = (groupActions?: TravellerActionGroupAction[]) => {
  const emailAction = groupActions?.find((action) => action.action === 'send_email');
  const smsAction = groupActions?.find((action) => action.action === 'send_sms');

  return (
    (!emailAction && isActionError(smsAction)) ||
    (!smsAction && isActionError(emailAction)) ||
    (isActionError(emailAction) && isActionError(smsAction))
  );
};
